import PropTypes from 'prop-types';
import React from 'react';
import { Nav } from 'reactstrap';
import DropNavigationItem from './DropNavigationItem';

const DropNavigationList = ({ itemData, classNames, isMobileNav }) => {
  const dropDownNavigationItems = itemData?.filter((item) => item.type === 'Multiple');

  const {
    drop, toggle, menu, wrapper,
  } = classNames;

  return (
    <Nav className={wrapper}>
      {dropDownNavigationItems?.map((item) => (
        <DropNavigationItem
          name={item.title}
          links={item.links}
          dropClassName={drop}
          toggleClassName={toggle}
          menuClassName={menu}
          key={`${item.title}}`}
          isMobileNav={isMobileNav}
        />
      ))}
    </Nav>
  );
};

const classNameTypes = PropTypes.shape({
  drop: PropTypes.string,
  toggle: PropTypes.string,
  menu: PropTypes.string,
  wrapper: PropTypes.string,
});

const linkType = PropTypes.shape({
  source: PropTypes.string,
  title: PropTypes.string,
  link: PropTypes.string,
});

const itemsType = PropTypes.shape({
  title: PropTypes.string,
  links: PropTypes.arrayOf(linkType),
});

DropNavigationList.defaultProps = {
  isMobileNav: false,
};

DropNavigationList.propTypes = {
  classNames: classNameTypes.isRequired,
  itemData: PropTypes.arrayOf(itemsType).isRequired,
  isMobileNav: PropTypes.bool,
};

export default DropNavigationList;
